import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

function BulkInvoice({singleOrder}) {
    const invoiceRef = useRef();
    // Function to generate PDF

    const handlePrint = useReactToPrint({
      content: () => invoiceRef.current,
      documentTitle: `${singleOrder?.numericOrderId}-Invoice`,
    });
  return (
    <div style={{position:'relative'}}>
      {/* Invoice Content */}
      <div ref={invoiceRef} style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
        <h1 style={{ textAlign: "center" }}>Invoice</h1>
        <p>Invoice Number: <strong>#{singleOrder?.numericOrderId}</strong></p>
        <p>Date: <strong>{new Date(singleOrder?.createdAt).toLocaleDateString()}</strong></p>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Item</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Mrp</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Quantity</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Discount</th>
              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {
                singleOrder && singleOrder.products.map((product)=>(
                    <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>{product.name}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{product.mrp}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>{product.quantity}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>{product.discount}%</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{product.subtotal}</td>
                  </tr>
                ))
            }
          </tbody>
          {/* <tfoot> */}
          <tr>
              <td colSpan="4" style={{ borderLeft: "1px solid #ddd", padding: "8px", textAlign: "right", }}>Shipping Cost</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{singleOrder?.shippingCost||0}</td>
            </tr>
            <tr>
              <td colSpan="4" style={{ borderLeft: "1px solid #ddd",borderBottom:'1px solid #ddd', padding: "8px", textAlign: "right" }}>Total</td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>₹{singleOrder?.totalPayableAmount}</td>
            </tr>
          {/* </tfoot> */}
        </table>
      </div>

      {/* Download Button */}
      <div style={{ textAlign: "center", marginTop: "20px",position:'absolute',right:10,top:10 }}>
        <button onClick={handlePrint} style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>
          Download PDF
        </button>
      </div>
    </div>
  )
}

export default BulkInvoice